function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.0137 7.22374C8.88585 7.09589 8.88585 6.90411 9.0137 6.77626L13.8082 1.98174C13.9361 1.85388 14 1.6621 14 1.53425C14 1.40639 13.9361 1.21461 13.8082 1.08676L12.9132 0.191781C12.7854 0.063927 12.5936 0 12.4658 0C12.274 0 12.1461 0.063927 12.0183 0.191781L7.22374 4.9863C7.09589 5.11416 6.90411 5.11416 6.77626 4.9863L1.98174 0.191781C1.85388 0.063927 1.6621 0 1.53425 0C1.40639 0 1.21461 0.063927 1.08676 0.191781L0.191781 1.08676C0.063927 1.21461 0 1.40639 0 1.53425C0 1.6621 0.063927 1.85388 0.191781 1.98174L4.9863 6.77626C5.11416 6.90411 5.11416 7.09589 4.9863 7.22374L0.191781 12.0183C0.063927 12.1461 0 12.3379 0 12.4658C0 12.5936 0.063927 12.7854 0.191781 12.9132L1.08676 13.8082C1.21461 13.9361 1.40639 14 1.53425 14C1.6621 14 1.85388 13.9361 1.98174 13.8082L6.77626 9.0137C6.90411 8.88585 7.09589 8.88585 7.22374 9.0137L12.0183 13.8082C12.1461 13.9361 12.3379 14 12.4658 14C12.5936 14 12.7854 13.9361 12.9132 13.8082L13.8082 12.9132C13.9361 12.7854 14 12.5936 14 12.4658C14 12.3379 13.9361 12.1461 13.8082 12.0183L9.0137 7.22374Z",
  fill: "black"
});

var SvgCloseIcon = function SvgCloseIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCloseIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/closeIcon.148b6a5f.svg";
export { ForwardRef as ReactComponent };